import { useState } from 'react'
import { Box, Button } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { ExpenseEntry } from './expeneEntry'
import { ExpenseApproval } from './expenseApproval'
import { ApprovedReport } from './expenseApprovedReport'
import { getExpenseTabsList } from './constant'
import { useTranslation } from '../../../i18n/I18nProvider'

const OperationsPrivilege = () => {
  const { translations } = useTranslation()
  const expenseTabsList = getExpenseTabsList(translations)
  const [searchParams, setSearchParams] = useSearchParams()
  const allGSPagesActive = JSON.parse(sessionStorage.getItem('token1')) || []
  const activetabsList = expenseTabsList.filter((item) => allGSPagesActive.find(a=>a.JobID === item.JobID)?.IsActive)
  const [masterNumber, setMasterNumber] = useState(Number(searchParams.get('tab'))||activetabsList?.[0]?.JobID)

  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.tab = lrTab
    setSearchParams(params)
    setMasterNumber(lrTab)
  }

  return (
    <Box sx={{ width: '100%', padding: '16px' }}>
      <Box className="brnchUsrMaster" style={{ padding: '0 0 10px 0' }}>
        {activetabsList?.map((val, i) => (
          <Button
            key={i}
            className={`brnchUsrMasterBtn ${masterNumber === val.JobID ? 'active' : ''}`}
            variant="outlined"
            onClick={() => goToTabs(val.JobID)}
            sx={{
              display: 'inline-block',
            }}
          >
            {val.name}
          </Button>
        ))}
      </Box>
      {masterNumber === expenseTabsList[0].JobID ? <ExpenseEntry /> : <></>}
      {masterNumber === expenseTabsList[1].JobID ? <ExpenseApproval /> : <></>}
      {masterNumber === expenseTabsList[2].JobID ? <ApprovedReport /> : <></>}
    </Box>
  )
}

export default OperationsPrivilege
